// import axios from "axios";
import {baseUrl} from "@/service/ApiClient";

export const urlWithContour = () => {
  // const url = window.location.origin
  const url =baseUrl()
  const demo = url.includes('demo.') ? 'demo.' : ''
  const eu = url.includes('eu.') ? 'eu.' : ''
  const contour =
    url.includes('dev.')
    ? 'dev.' : url.includes('beta.')
    ? 'beta.' : url.includes('enterprise')
    ? 'enterprise.' : url.includes('localhost')
    ? 'beta.' : ''
  return 'https://'+eu + contour + demo + 'lfqr.cc'
}
